import { render, staticRenderFns } from "./hospitalsupplyment.vue?vue&type=template&id=3545b21d"
import script from "./hospitalsupplyment.vue?vue&type=script&lang=js"
export * from "./hospitalsupplyment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports